import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FilterOptions } from '../notification-filter/notification-filter.component';

@Injectable({
  providedIn: 'root'
})
export class FilterOverlayDialogService {
  constructor() {}
  private statusEle = [];
  recipientFilters = {
    statusFilters: [
      {
        label: '',
        value: ''
      }
    ],
    dateSent: {
      startDate: '',
      endDate: ''
    },
    dateDelivered: {
      startDate: '',
      endDate: ''
    },
    dateRead: {
      startDate: '',
      endDate: ''
    },
    feedbackReceived: {
      startDate: '',
      endDate: ''
    }
  };

  private statusFilter = new BehaviorSubject(this.statusEle);
  private datesentFilter = new BehaviorSubject(this.recipientFilters.dateSent);
  private datedeliveredFilter = new BehaviorSubject(this.recipientFilters.dateDelivered);
  private datereadFilter = new BehaviorSubject(this.recipientFilters.dateRead);
  private feedbackReceivedFilter = new BehaviorSubject(this.recipientFilters.feedbackReceived);
  private filterNotificationData = new Subject<FilterOptions>();
  // Observable string streams
  public statusFilterobservable$ = this.statusFilter.asObservable();
  public datesentFilterobservable$ = this.datesentFilter.asObservable();
  public datedeliveredFilterobservable$ = this.datedeliveredFilter.asObservable();
  public datereadFilterobservable$ = this.datereadFilter.asObservable();
  public feedbackReceivedFilterobservable$ = this.feedbackReceivedFilter.asObservable();

  public filterData$ = this.filterNotificationData.asObservable();

  public setStatusName(uniqueStatus: any): void {
    this.statusEle = [];
    uniqueStatus.forEach(status => {
      const statusObj = {
        label: status,
        value: status
      }
      this.statusEle.push(statusObj)
    });
    this.statusFilter.next(this.statusEle);
  }
  public getFilteredData(filterDataObject): void {
    this.filterNotificationData.next(filterDataObject);
    // console.log('filters in service', filterDataObject);
  }
}
